import { Snackbar, IconButton, Stack, styled } from '@ltvco/refresh-lib/theme';

export const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  transform: 'none',
  width: '100%',
  maxWidth: '100%',
  backgroundColor: theme.palette.primary.light,
  borderTop: `1px solid ${theme.palette.divider}`,
  borderRadius: 0,
  padding: 0,
  minWidth: 'auto',
}));

export const SnackbarContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  minHeight: '80px',
  backgroundColor: theme.palette.primary.light,
  padding: theme.spacing(1, 1.5),
  paddingBottom: `calc(${theme.spacing(1)} + env(safe-area-inset-bottom, 0px))`,
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: theme.palette.background.light,
  '&:hover': {
    backgroundColor: theme.palette.text.disabled,
  },
}));
